import { useEffect, useState } from 'react';

/**
 * Returns true when the viewport is at or below the mobile breakpoint.
 * Updates live on resize / orientation change.
 *
 * Default breakpoint: 768px (covers phones; tablets in landscape stay desktop).
 */
export function useIsMobile(breakpoint = 768): boolean {
  const getMatch = () =>
    typeof window !== 'undefined' && window.innerWidth <= breakpoint;

  const [isMobile, setIsMobile] = useState<boolean>(getMatch);

  useEffect(() => {
    function onResize() {
      setIsMobile(window.innerWidth <= breakpoint);
    }
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, [breakpoint]);

  return isMobile;
}
